import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import ReferenceDatatable from '@/components/references/ReferenceDatatable.vue'
import { computed, useTemplateRef } from 'vue'
import { useI18n } from 'vue-i18n'


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'SalaryDatatable'
},
  __name: 'SalaryDatatable',
  setup(__props, { expose: __expose }) {



const { t } = useI18n()
const datatable =
  useTemplateRef<InstanceType<typeof ReferenceDatatable>>('datatable')

const headers = computed(() => ({
  title: { title: `${t('general.number')} - ${t('salary.recipient')}` },
  date: { title: t('salary.labels.payment_date') }
}))

__expose({
  refresh: () => datatable.value?.refresh()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ReferenceDatatable, {
    ref_key: "datatable",
    ref: datatable,
    endpoint: "payslips?orderby=id&desc=true",
    headers: headers.value
  }, null, 8, ["headers"]))
}
}

})